/**
 * Finds annotations with a `end` property equal to a particular identifier.
 *
 * @param {Array<object>} annotations
 * @param {string} identifier
 * @returns {Array<object>}
 */
const getAnnotationsEndingRelativeToNodeIdentifier = (
  annotations,
  identifier,
) => annotations.filter(({ end }) => end === identifier);

export default getAnnotationsEndingRelativeToNodeIdentifier;
